module.exports = __webpack_public_path__ + "img/nitda.7412c43e.svg";